// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  margin: 0px;
  padding: 0px;
}
.bg-body-tertiary {
  justify-self: start;
  background-color: transparent !important;
  width: 100%;
  margin: 0px;
  padding: 0.5rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.navbar {
  --bs-navbar-padding-y: 0 !important;
}
.navLink {
  margin: 1rem;
}
.nav-link.active {
  color: aqua !important;
}
.logo {
  justify-self: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.navContent {
  align-self: flex-end;
}

.navContainer {
  display: flex;
  flex-direction: row;
}
.resumeButton {
  margin-top: -5px;
  align-self: center;
  justify-self: center;
  background-color: rgb(31, 30, 30) !important;
  border-color: rgba(34 211 238) !important;
  outline: transparent !important;
}

@media screen and (max-width: 767px) {
  .navLink {
  }

  .bg-body-tertiary {
    margin-top: 1.5rem;
  }

  #basic-navbar-nav {
    margin-left: -7.3rem !important;
  }

  .navBurger.collapsed {
    margin-left: -3.3rem;
  }

  .navBurger {
    margin-left: -7.3rem !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/SiteNavbar.css"],"names":[],"mappings":"AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,4CAA4C;EAC5C,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE;EACA;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');\r\nhtml,\r\nbody {\r\n  margin: 0px;\r\n  padding: 0px;\r\n}\r\n.bg-body-tertiary {\r\n  justify-self: start;\r\n  background-color: transparent !important;\r\n  width: 100%;\r\n  margin: 0px;\r\n  padding: 0.5rem;\r\n  margin-bottom: 2rem;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.navbar {\r\n  --bs-navbar-padding-y: 0 !important;\r\n}\r\n.navLink {\r\n  margin: 1rem;\r\n}\r\n.nav-link.active {\r\n  color: aqua !important;\r\n}\r\n.logo {\r\n  justify-self: flex-start;\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.navContent {\r\n  align-self: flex-end;\r\n}\r\n\r\n.navContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n.resumeButton {\r\n  margin-top: -5px;\r\n  align-self: center;\r\n  justify-self: center;\r\n  background-color: rgb(31, 30, 30) !important;\r\n  border-color: rgba(34 211 238) !important;\r\n  outline: transparent !important;\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .navLink {\r\n  }\r\n\r\n  .bg-body-tertiary {\r\n    margin-top: 1.5rem;\r\n  }\r\n\r\n  #basic-navbar-nav {\r\n    margin-left: -7.3rem !important;\r\n  }\r\n\r\n  .navBurger.collapsed {\r\n    margin-left: -3.3rem;\r\n  }\r\n\r\n  .navBurger {\r\n    margin-left: -7.3rem !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
